import { dataTemplateSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTemplateSolid = /*#__PURE__*/createIcon(dataTemplateSolid)
export default IconTemplateSolid
